/**
 * Portal Manta · executarPipeline
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { PIPELINES } from '../../data/pipelines.js';
import { AGENTES_CATALOG } from '../../data/agentes-catalog.js';
import { API } from '../../app-globals.js';

async function executarPipeline(pipelineId, contexto, onProgresso){
  const p = PIPELINES[pipelineId];
  if (!p) throw new Error('pipeline desconhecido: '+pipelineId);
  const resultados = {};
  for (const aId of p.agentes) {
    const a = AGENTES_CATALOG[aId];
    if (!a) { onProgresso?.({agenteId:aId, status:'erro', erro:'agente não existe no catálogo'}); continue; }
    onProgresso?.({agenteId:aId, status:'rodando', nome:a.nome});
    try {
      await new Promise(r => setTimeout(r, 250));
      let out;
      if (a.tipo === 'local' && a.fn) {
        out = await a.fn(contexto, resultados);
      } else if (a.tipo === 'backend') {
        if (!API.enabled) {
          out = {status:'pulado', msg:'backend OFF'};
        } else if (a.fn) {
          out = await a.fn(contexto, resultados);
        } else {
          out = await API.post(a.endpoint, contexto);
        }
      } else {
        out = {status:'sem-fn', msg:'agente sem função local'};
      }
      resultados[aId] = out;
      onProgresso?.({agenteId:aId, status:out?.status==='erro'||out?.status==='pulado'?out.status:'ok', output:out});
    } catch(e) {
      resultados[aId] = {status:'erro', erro:e.message};
      onProgresso?.({agenteId:aId, status:'erro', erro:e.message});
    }
  }
  return resultados;
}

export { executarPipeline };
export default executarPipeline;
